import { Button, Card } from '../../atoms';
import { CloseIcon } from 'components/icons';
import { CloseWhiteIcon } from '../../icons';
import { memo, PropsWithChildren, useEffect } from 'react';
import classes from 'classnames';
import styles from './Modal.module.scss';

type Action = {
  text: string;
  onClick: () => void;
};

export type Props = {
  actions?: Array<Action>;
  className?: string;
  classNameContainer?: string;
  classNameWrapper?: string;
  classNameContent?: string;
  dataTest?: string;
  isMobileFullWidth?: boolean;
  isOpen: boolean;
  onClose?: () => void;
  onCloseOutside?: () => void;
  onClickOutside?: () => void;
  title?: string;
};

export default memo(function Modal({
  actions,
  dataTest = 'Modal',
  isOpen,
  onClose,
  onCloseOutside,
  onClickOutside,
  children,
  className,
  classNameContainer,
  classNameWrapper,
  classNameContent,
  title,
  isMobileFullWidth = false,
}: PropsWithChildren<Props>) {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'inherit';
    return () => {
      document.body.style.overflow = 'inherit';
    };
  }, [isOpen]);

  return isOpen ? (
    <>
      <div className={classes(styles.backdrop, classNameContainer)}>
        {onCloseOutside && (
          <button
            className={classes(styles['close-btn'], styles['close-white-btn'])}
            data-test={`${dataTest}-btn`}
            data-testid={`${dataTest}-btn`}
            onClick={onClose}
          >
            <CloseWhiteIcon
              fill="purple"
              className={styles['close-white-icon']}
              data-test={`${dataTest}-icon-close`}
              data-testid={`${dataTest}-icon-close`}
            />
          </button>
        )}
      </div>
      <div
        className={classes(
          styles['modal-wrapper'],
          isMobileFullWidth && styles['modal-wrapper-full-width'],
          classNameWrapper,
        )}
        onClick={onClickOutside}
      >
        <Card
          className={classes(
            styles.modal,
            className,
            isMobileFullWidth && styles['modal-full-width'],
          )}
          dataTest={`${dataTest}-card`}
        >
          {title && (
            <div className={styles.title} data-test={`${dataTest}-title`}>
              {title}
            </div>
          )}
          {onClose && (
            <button
              className={styles['close-btn']}
              data-test={`${dataTest}-btn-close`}
              onClick={onClose}
            >
              <CloseIcon data-test={`${dataTest}-btn-close-icon`} />
            </button>
          )}

          <div className={classes(styles.content, classNameContent)}>
            {children}
            {actions?.map((action) => (
              <Button
                key={action.text}
                className={styles['action-btn']}
                dataTest={`${dataTest}-btn-content`}
                onClick={action.onClick}
              >
                {action.text}
              </Button>
            ))}
          </div>
        </Card>
      </div>
    </>
  ) : (
    <></>
  );
});
